import { StatusReturningAge } from '../components/StatusIcon';
/**
 * Expects a date string and returns if that date is older than the StatusReturningAge.
 * @param dateExecuted The date to check (may be undefined).
 * @returns True if the date is older than the StatusReturningAge and false if not (or if it is undefined).
 */
export const isDateReturning = (dateExecuted) => {
    return dateExecuted && Date.now() - new Date(dateExecuted).getTime() > StatusReturningAge;
};
